import React from 'react';
import { Box, Pagination, Typography } from '@mui/material';

const KnowledgePagination = ({
  total,
  pageCount,
  currentPage,
  isCompact,
  isTablet,
  onPageChange,
}) => {
  if (total <= 0) return null;

  return (
    <Box
      display='flex'
      flexDirection={{ xs: 'column', sm: 'row' }}
      justifyContent='center'
      alignItems='center'
      gap={1.5}
      mt={3}
    >
      <Typography variant='caption' color='text.secondary'>
        {total} chunk{total === 1 ? '' : 's'}
        {pageCount > 1 ? ` · Page ${currentPage} of ${pageCount}` : ''}
      </Typography>
      {pageCount > 1 && (
        <Pagination
          count={pageCount}
          page={currentPage}
          onChange={onPageChange}
          color='primary'
          shape='rounded'
          size={isCompact ? 'small' : 'medium'}
          siblingCount={isCompact ? 0 : isTablet ? 1 : 2}
          boundaryCount={1}
        />
      )}
    </Box>
  );
};

export default KnowledgePagination;
